import type { Article } from '@/pages/Article/hooks/useArticle';

export const validateMarketArticle = (article?: Article): boolean => {
  const allowedTags = ['market-wrap-up', 'best-performers', 'education'];
  if (!article) {
    return false;
  }
  const { tags } = article;
  if (tags === null) {
    return false;
  }
  if (!tags?.theme) {
    return false;
  }
  if (Array.isArray(tags.theme) === false) {
    return false;
  }
  for (const tag of tags.theme) {
    if (allowedTags.includes(tag)) {
      return true;
    }
  }
  return false;
};
